import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CookieService } from '@angular/synthrone-design/services';
import { Observable } from 'rxjs/Observable';
import { SynthroneDataService } from '@synthroneApp/services/synthrone-data/synthrone-data.service';

@Injectable()
export class AuthenticateGuard implements CanActivate {

    constructor(private DS: SynthroneDataService, private cookieService: CookieService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const systemToken = this.cookieService.getCookie('systemToken', false, true);
        if (systemToken && this.isTokenStillValid(systemToken)) {
            return true;
        } else {
            this.DS.logout();
            return false;
        }
    }

    isTokenStillValid(systemToken): boolean {
        const tokenData = JSON.parse(window.atob(systemToken.split('.')[0]));
        if (+new Date(tokenData['stt'] * 1000) >= +new Date) {
            return true;
        }
        return false
    }
}


// WEBPACK FOOTER //
// ./src/app/guards/authenticate/authenticate.guard.ts